import { OnboardingFlowTerminusNode } from '@scale/shared/onboardingControlPanel';
import { OutlineSection } from 'react-scale/remotasks.com/components/Expert/OutlinePanel';
import { OutlineSectionV2 } from 'react-scale/remotasks.com/components/Expert/OutlinePanel/OutlineSectionV2';
import { OutlineSectionTitleAdornment } from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/components/OutlineSectionTitleAdornment';
import {
  useGetOutlineNodeStatus,
  useProjectOutlineStore,
} from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/stores/projectOutlineStore';
import { ProjectOutlineNodeStatus } from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/types';
import { useUser } from 'react-scale/components/ui/UserContext';
import useUnleashFeatureFlag from 'react-scale/hooks/useUnleashFeatureFlag';

type CurrentTaskSectionProps = {
  node: OnboardingFlowTerminusNode;
};
export const CurrentTaskSection = ({ node }: CurrentTaskSectionProps) => {
  const user = useUser();
  const useNewMpView = useUnleashFeatureFlag('mp-nav-change', { userId: user._id }, true);
  const { status, selected } = useGetOutlineNodeStatus(node);
  const taskingPayRate = useProjectOutlineStore(state => state.taskingPayRate);
  const payRateType = useProjectOutlineStore(state => state.payRateType);

  return useNewMpView ? (
    <OutlineSectionV2
      title="Current task"
      active={selected}
      steps={[]}
      muted={status === ProjectOutlineNodeStatus.NOT_STARTED}
      titleEndAdornment={
        <OutlineSectionTitleAdornment
          status={status}
          payRate={taskingPayRate}
          payRateType={payRateType}
        />
      }
    />
  ) : (
    <OutlineSection
      title="Current task"
      active={selected}
      steps={[]}
      muted={status === ProjectOutlineNodeStatus.NOT_STARTED}
      titleEndAdornment={
        <OutlineSectionTitleAdornment
          status={status}
          payRate={taskingPayRate}
          payRateType={payRateType}
        />
      }
    />
  );
};
